import { Outlet } from "react-router";
import { PostHogInstrumentation, WithPostHog } from "./posthog";
import { MaintenanceGuard } from "./guards/MaintenanceGuard";
import { SKIP_MAINTENANCE_CHECK } from "./constants";
import { MaintenanceAnnouncement } from "./components/MaintenanceAnnouncement";

export function Root() {
  const content = (
    <>
      <MaintenanceAnnouncement />
      <WithPostHog>
        <PostHogInstrumentation>
          <Outlet />
        </PostHogInstrumentation>
      </WithPostHog>
    </>
  );

  if (!SKIP_MAINTENANCE_CHECK) {
    return <MaintenanceGuard>{content}</MaintenanceGuard>;
  }

  return content;
}
